import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_mobile_app_version_update_deleteMobileAppUpdateVersion, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_mobile_app_version_update_deleteMobileAppUpdateVersion';

export type MobileUpdateVersionModelType = Response200Type;

const decode = (status: number, data: ResponseType): MobileUpdateVersionModelType => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface MobileUpdateVersionTypeSubmitType {
    app_version: string, platform: string
}

export const deleteMobileUpdateVersion = {
    browser: {
        params: (params: MobileUpdateVersionTypeSubmitType): ParamsFetchType<MobileUpdateVersionTypeSubmitType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/delete-app-mobile-version',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/delete-app-mobile-version',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<MobileUpdateVersionTypeSubmitType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const response = await openapi_mobile_app_version_update_deleteMobileAppUpdateVersion(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
